import type { LeadsType } from "app/pages/sales-intelligence/domain/leads/types/lead";
import type { LeadsSearchRowKeys } from "app/pages/sales-intelligence/modules/leads-search";
import type { PaginatedTableRequest } from "app/pages/sales-intelligence/types/table";

export const ORDER_BY_MAP: Record<LeadsType, LeadsSearchRowKeys> = {
    companies: "company_employee_range",
    websites: "visits",
};

export const DEFAULT_ORDER_ASC = false;

/** Default table sort while "My territory filters" is active (high → low). */
export const TERRITORY_ORDER_BY: LeadsSearchRowKeys = "lead_priority";

export const DEFAULT_PAGE = 1;

export const DEFAULT_PAGE_SIZE = 50;

export const LEAD_DOMAINS_TABLE_PAGE_SIZE = 5;

export const COMPANY_DOMAINS_DEFAULT_REQUEST: PaginatedTableRequest = {
    asc: false,
    orderBy: ORDER_BY_MAP.websites,
    page: DEFAULT_PAGE,
    pageSize: LEAD_DOMAINS_TABLE_PAGE_SIZE,
};
